import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Page } from './Page';
import { CONSTANTS } from '../../assets/UIConstants';
import Paper from 'material-ui/Paper';
import { Scan } from '../../data_layer/models/Scan';
import Button from 'material-ui/Button';
import { computed } from 'mobx';
import { CSSProperties } from 'react';
import { Link } from 'react-router-dom';

interface Props {
}

interface State {
    scansToShow: number;
}

const INITIAL_SCANS_COUNT: number = 6;
const SCANS_COUNT_INCREMENT: number = 6;

@inject('store')
@observer
export class History extends Page<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            scansToShow: INITIAL_SCANS_COUNT,
        };
    }

    @computed get scans(): Scan[] {
        if (this.props.store && this.props.store.scanStore && this.props.store.scanStore.storeIsReady) {
            const sorted = this.props.store.scanStore.sortedByDateDescending;
            const slice = sorted.slice(0, this.state.scansToShow);
            return slice;
        }
        return [];
    }

    private showMoreScans(): void {
        this.setState((prevState: State) => {
            return {
                scansToShow: prevState.scansToShow + SCANS_COUNT_INCREMENT,
            };
        });
    }

    private renderLineItem(scan: Scan, index: number): React.ReactNode {
        return (
            <div key={index} style={lineItemRowContainer}>
                <div>
                    <div style={cellContentFix}>
                        <div style={dotStyle}>&nbsp;</div>
                        {scan.created_at.format('MM/DD/YYYY')}
                    </div>
                </div>
                <div>
                    {scan.created_at.format('h:mm A')}
                </div>
                <Link to={`/history/${scan.id}`} style={lineItemLinkCell}>
                    View Full Scan
                </Link>
            </div>
        );
    }

    public renderPage(): React.ReactNode {
        return (
            <div style={outerContainer}>
                <Paper style={paperStyle}>
                    <div style={contentContainer}>
                        <div style={contentHeader}>
                            Previous Scans
                        </div>
                        <div style={scanListContainer}>
                            {this.scans.map((scan: Scan, index: number) => {
                                return this.renderLineItem(scan, index);
                            })}
                        </div>

                        <Button
                            style={viewMoreButtonStyle}
                            onClick={() => { this.showMoreScans(); }}
                        >
                            View More
                        </Button>
                    </div>
                </Paper>
            </div>
        );
    }
}

const paperStyle: CSSProperties = {
    boxShadow: CONSTANTS.BOX_SHADOW.PANEL,
    border: '1px solid ' + CONSTANTS.COLORS.BORDER_GREY,
    borderRadius: '10px',
    backgroundColor: CONSTANTS.COLORS.WHITE,
    boxSizing: 'border-box',
    maxWidth: 1200 + 'px',
    marginLeft: 'auto',
    marginRight: 'auto',
};

const dotStyle: CSSProperties = {
    border: 'solid',
    borderColor: CONSTANTS.COLORS.THEME_BLUE,
    borderRadius: 100 + '%',
    borderWidth: 9 + 'px',
    width: 9 + 'px',
    height: 9 + 'px',
    marginRight: 25 + 'px',
};

const cellContentFix: CSSProperties = {
    display: 'flex',
};

const outerContainer: CSSProperties = {
    flexGrow: CONSTANTS.FLEX_GROW.ONE,
    overflowY: 'auto',
    paddingLeft: 32,
    paddingRight: 32,
    paddingTop: 20,
    paddingBottom: 50,
    marginRight: 80 + 'px',
    marginLeft: 80 + 'px',
};

const contentContainer: CSSProperties = {
    paddingTop: 40 + 'px',
    paddingBottom: 40 + 'px',
};

const viewMoreButtonStyle: CSSProperties = {
    borderRadius: 60 + 'px',
    lineHeight: 40 + 'px',
    paddingRight: 40 + 'px',
    paddingLeft: 40 + 'px',
    fontSize: 16 + 'px',
    fontWeight: 'bold',
    color: CONSTANTS.COLORS.BUTTON_TEXT_GREY,
    backgroundColor: CONSTANTS.COLORS.BUTTON_BACKGROUND_GREY,
    textTransform: 'none'
};

const contentHeader: CSSProperties = {
    fontSize: 30 + 'px',
    marginBottom: 60 + 'px'
};

const scanListContainer: CSSProperties = {
    paddingLeft: 180 + 'px',
    paddingRight: 180 + 'px',
    paddingBottom: 20 + 'px',
};

const lineItemRowContainer: CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${CONSTANTS.COLORS.BUTTON_OUTLINE_GREY}`,
    fontSize: 22 + 'px',
    paddingBottom: 20 + 'px',
    marginTop: 20 + 'px',
};

const lineItemLinkCell: CSSProperties = {
    textDecoration: 'none',
    color: CONSTANTS.COLORS.THEME_BLUE,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/pages/History.tsx